module.exports = "/assets/cola-page/logo_2.png?g0hSRt5";